import { IconProps } from '@euler/app/components/icons/types';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { Option } from '@euler/model';
import { OldPartDisposalType } from '@euler/model/enum';
import { memo } from 'react';
import { Path, Svg } from 'react-native-svg';
import { useOrderFlowContext } from '../../../../OrderFlowContext';
import { IconWrapper } from '../components/IconWrapper';
import InlineRadios from '../components/InlineRadios';
import { Row } from '../components/Row';
import { RowErrorText } from '../components/RowErrorText';

const kOptions: Option<OldPartDisposalType>[] = [
  { value: OldPartDisposalType.Keep, text: '需保留' },
  {
    value: OldPartDisposalType.KeepForLook,
    text: '需查看',
  },
];

export const OldPartDisposalTypeRow = memo(
  ({ required, ...props }: { required?: boolean; disabled?: boolean }) => {
    const {
      theme,
      formController: { form },
    } = useOrderFlowContext();

    const { iconColor } = theme;

    return (
      <Row
        errorProp="oldPartDisposalType"
        note={<RowErrorText error={form.oldPartDisposalType.error} />}
        required={required}
        title="旧件处理"
        icon={
          <IconWrapper>
            <RowIcon color={iconColor} />
          </IconWrapper>
        }
        detail={
          <InlineRadios
            options={kOptions}
            value={form.oldPartDisposalType.value}
            disabled={props.disabled}
            onChange={form.oldPartDisposalType.update}
          />
        }
        {...props}
      />
    );
  },
);

const RowIcon = memo(({ width, height, color, style, ...props }: IconProps) => {
  const { rpx } = useResponsiveContext();
  return (
    <Svg
      viewBox="0 0 1024 1024"
      width={width ?? rpx(21)}
      height={height ?? rpx(21)}
      style={style}
      fill="none"
      {...props}
    >
      <Path
        d="M278.788 687.797c10.89 18.089 34.377 24.028 52.465 13.14 18.088-10.89 24.028-34.377 13.139-52.466l-58.674-97.73c-15.389-25.647-53.005-24.477-66.774 2.07L77.568 826.204c-32.396 62.633 4.86 123.107 75.593 123.107h232.627c21.148 0 38.246-17.098 38.246-38.246s-17.098-38.246-38.246-38.246H153.16c-13.589 0-13.589 0.09-7.56-11.429l109.88-212.469 23.307 38.876z m419.988 150.105c10.35-18.448 3.78-41.755-14.578-52.104-18.448-10.35-41.756-3.78-52.105 14.578l-51.655 91.881c-14.308 25.467 4.14 56.964 33.387 56.964h256.924c70.733 0 107.9-60.834 75.323-123.827L824.584 590.517c-9.72-18.808-32.757-26.097-51.565-16.378s-26.097 32.757-16.378 51.565L878.128 860.58c6.21 11.969 6.12 12.149-7.379 12.149H679.16l19.617-34.827zM570.09 358.34c-21.148 0.09-38.156 17.369-37.976 38.517 0.09 21.147 17.368 38.156 38.516 37.976l110.51-0.72c28.526-0.18 46.884-30.417 33.746-55.795L580.978 119.504c-33.747-65.333-104.66-64.253-138.406 0.9L310.735 375.26c-9.719 18.808-2.34 41.845 16.378 51.565 18.809 9.629 41.936 2.34 51.655-16.469l131.747-254.764c5.49-10.62-2.43-10.53 2.52-0.9l105.2 203.47-48.146 0.18z m76.763 55.165l33.746-55.795-62.454 0.36 28.708 55.435z"
        fill={color}
      />
    </Svg>
  );
});
